module.exports = __webpack_public_path__ + "img/img2.1de4131e.svg";